export const FIELD_CONSTANTS = {
  CANCEL: "cancel",
  LANGUAGE: "Language",
  SAVE: "save",
  TITLE: "Title",
  UPLOAD_MEDIA: "Upload Media",
};
